import { Validator } from '@vista-digital/validator';
import { customFilmActionsValidator } from '../../../../types/custom-film-actions';
export const defaultOccFilmConfig = {
    customActions: {},
    showWatchlistButtons: false
};
export const occFilmConfigValidator = Validator.object({
    customActions: customFilmActionsValidator,
    showWatchlistButtons: Validator.boolean()
});
//# sourceMappingURL=film.js.map